import { createSlice } from '@reduxjs/toolkit';

const animationSlice = createSlice({
  name: 'animation',
  initialState: {
    isActive: false,
  },
  reducers: {
    setIsAnimationActive: (state, action: { payload: boolean }) => {
      state.isActive = action.payload;
    },
  },
});

export const { setIsAnimationActive } = animationSlice.actions;
export default animationSlice.reducer;
